import { episodeAgainstChartsFrom } from '../episode/chartMovedAt';
import { PDGM_PERIOD_1_ROW_CLASS } from '../../utils/pdgmPeriodUtils';

/** Same faint hatch as an in-episode external calendar day. */
export const EXTERNAL_EMR_HATCH_CLASS = 'external-emr-hatch';

export const EXTERNAL_MANAGED_ROW_CLASS = `${EXTERNAL_EMR_HATCH_CLASS} hover:bg-slate-50`;

/** Period 1 keeps its slate wash; the hatch sits on top of it. */
export const EXTERNAL_MANAGED_PERIOD_1_ROW_CLASS = `${EXTERNAL_EMR_HATCH_CLASS} ${PDGM_PERIOD_1_ROW_CLASS}`;

const DELETED_ROW_CLASS =
  'border-l-2 border-destructive/70 bg-destructive/5 hover:bg-destructive/10';

/**
 * Slanted hatch: a charts-from day is set and the row is dated before it
 * (EMR-3239). Any episode, including one that ended before the day.
 */
export function taskShowsPreTakeOverHatch(
  task: { task_date?: string | null; scheduled_date?: string | null },
  rogerChartsFrom: string | null | undefined
): boolean {
  const day = task.task_date ?? task.scheduled_date;
  return !!rogerChartsFrom && !!day && day < rogerChartsFrom;
}

/**
 * One tone per row. Deleted wins over the hatch. An external chart on a
 * period-1 row keeps the slate wash under the hatch. Every tone is classes,
 * so hover can replace the resting wash; an inline background would freeze it.
 */
export function taskRowToneClass(options: {
  deleted: boolean;
  period1: boolean;
  preTakeOverHatch: boolean;
}): string {
  if (options.deleted) return DELETED_ROW_CLASS;
  if (options.preTakeOverHatch && options.period1) {
    return EXTERNAL_MANAGED_PERIOD_1_ROW_CLASS;
  }
  if (options.preTakeOverHatch) return EXTERNAL_MANAGED_ROW_CLASS;
  if (options.period1) return PDGM_PERIOD_1_ROW_CLASS;
  return 'hover:bg-muted/35';
}

type ChartsFromEpisode = {
  start_date: string;
  end_date: string;
  roger_charts_from: string | null | undefined;
};

/**
 * Where the "Roger charts from" row sits, or -1 when this episode does not
 * contain that day. The day itself is Roger's, matching custody: a row dated
 * before it is still the External EMR's. `rowDays.length` means after the
 * last row.
 */
export function chartsFromSeparatorIndex(
  rowDays: readonly (string | null | undefined)[],
  episode: ChartsFromEpisode | null
): number {
  if (!episode || episodeAgainstChartsFrom(episode) !== 'contains') return -1;
  const day = episode.roger_charts_from ?? '';
  const index = rowDays.findIndex(rowDay => (rowDay ?? '') >= day);
  return index === -1 ? rowDays.length : index;
}
